import { computed, makeObservable } from 'mobx';

import { CatalogFormFieldEntity } from 'entities/CatalogFormField';
import { FormFieldTableRow } from 'entities/Form';
import { ILocalStore } from 'stores/interfaces';

import { FormFieldModel } from '../../models';
import { IEditFormStore } from '../interface';

type EditFormStoreDataStoreParams = {
  editFormStore: IEditFormStore;
};

/** Стор для работы с сущностью строчек таблицы */
class EditFormStoreDataStore implements ILocalStore {
  constructor({ editFormStore }: EditFormStoreDataStoreParams) {
    this._editFormStore = editFormStore;

    this.getTableRowEntityByCatalogId =
      this.getTableRowEntityByCatalogId.bind(this);

    makeObservable(this, {
      data: computed,
    });
  }

  private readonly _editFormStore: IEditFormStore;

  /**
   * Данные для таблицы
   */
  get data(): FormFieldTableRow<FormFieldModel, CatalogFormFieldEntity>[] {
    return this._editFormStore.formStore.fieldsCollection.map<
      FormFieldTableRow<FormFieldModel, CatalogFormFieldEntity>
    >((formField) => {
      return {
        formField,
        catalogField: this._createDefaultCatalogField(formField),
      };
    });
  }

  getTableRowEntityByCatalogId(
    id: string
  ): FormFieldTableRow<FormFieldModel, CatalogFormFieldEntity> | null {
    return (
      this.data.find((entity) => String(entity.formField.id) === id) || null
    );
  }

  private _createDefaultCatalogField(
    formField: FormFieldModel
  ): CatalogFormFieldEntity {
    if (formField.custom) {
      return {
        dataType: formField.fieldData.dataType,
        label: formField.fieldData.name,
        id: formField.fieldData.id,
        setupRequired: false,
        required: false,
      };
    }

    return this._editFormStore.formStore.catalogStore.fieldsCollection[
      formField.relatedCatalogFieldId
    ];
  }

  destroy() {
    // do nothing
  }
}

export default EditFormStoreDataStore;
